import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  EnsureLeadSuggestedContactsMutation,
  EnsureLeadSuggestedContactsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "lib/hooks/api/useGraphQlClient";

const ENSURE_LEAD_SUGGESTED_CONTACTS_MUTATION = graphql(`
  mutation ensureLeadSuggestedContacts($leadId: String!) {
    ensureLeadSuggestedContacts(leadId: $leadId)
  }
`);

/**
 * Asks for contact recommendations on a lead that has never had them — one created before the
 * feature existed. The server generates at most once per lead, so calling this on open is safe
 * however many times it happens; the response says whether a run actually started.
 */
export function useEnsureLeadSuggestedContacts(
  options?: UseMutationOptions<
    EnsureLeadSuggestedContactsMutation,
    unknown,
    EnsureLeadSuggestedContactsMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(ENSURE_LEAD_SUGGESTED_CONTACTS_MUTATION, options);
}
